import { Avatar } from '@/components/ui/avatar';
import { ProfilesResponse } from '@/features/user';
import { cn } from '@/lib/utils';

import { avatarMapLegacy, AvatarLegacyKey } from './avatar-map-legacy';

interface ProfileAvatarProps {
  profile: ProfilesResponse.Profile;
  onSelect: (profileId: string) => void;
  loading?: boolean;
  disabled?: boolean;
  selected?: boolean;
}

const ProfileAvatar = ({
  profile,
  onSelect,
  loading,
  disabled,
  selected,
}: ProfileAvatarProps) => {
  const avatar = profile.avatar || 'bird0001';
  // Check if avatar exists in avatarMapLegacy, otherwise use default
  const avatarKey = (
    avatar in avatarMapLegacy ? avatar : 'bird0001'
  ) as AvatarLegacyKey;
  return (
    <div className="flex flex-col items-center gap-2 cursor-pointer w-fit">
      <div className="relative">
        <Avatar
          icon={avatarMapLegacy[avatarKey]}
          onClick={() => onSelect(profile.id)}
          className={cn(
            'size-20',
            selected ? 'border-4 border-bhanzu-orange' : ''
          )}
          role="button"
          disabled={disabled}
          loading={loading}
        />
        {selected ? (
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-bhanzu-orange rounded-full flex items-center justify-center">
            <svg
              className="w-4 h-4 text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        ) : null}
      </div>
      <span
        className={`text-sm font-medium text-center ${
          selected
            ? 'text-bhanzu-orange font-semibold'
            : 'text-magical-moonlight-d3'
        }`}
      >
        {profile.name}
      </span>
    </div>
  );
};

export default ProfileAvatar;
